import React from "react";
import {NamespaceInput} from "../namespace/NamespaceInput";
import {ClazzInput} from "../clazz/ClazzInput";
import {MethodInput} from "../method/MethodInput";
import {PersistenceInput} from "../persistence/PersistenceInput";
import {DeletionInput} from "../deletion/DeletionInput";
import styles from "./MyForm.module.css";
import Tools from "../diagram/tools/Tools";
import { DiagramPositionInput } from "../diagram/diagramPosition/DiagramPositionInput";
import {TextMeasurer} from "../diagram/text-measurer/TextMeasurer";
import {LazilyAddInput} from "../lazilyAdd/LazilyAddInput";
import {Clazz} from "../clazz/clazz";
import {Method} from "../method/method";
import {useAppSelector} from "../../@app/hooks";
import {selectClazzes} from "../clazz/clazzSlice";
import IconButton from "@mui/material/IconButton";
import {Link as LinkIcon} from "@mui/icons-material";
import {selectUserToken} from "../user/userSlice";
import {MySnackbar} from "../../@shared/snackbar/MySnackbar";

export function MyForm() {
  const [formNamespace, setFormNamespace] = React.useState<string | null>(null);
  const [formClazz, setFormClazz] = React.useState<Clazz | null>(null);
  const [formMethod, setFormMethod] = React.useState<Method | null>(null);
  const [snackbarMessage, setSnackbarMessage] = React.useState('');

  const clazzesMap: Record<string, Clazz> = useAppSelector(selectClazzes);
  const userToken = useAppSelector(selectUserToken);

  const handleNamespaceChange = (namespace: string) => {
    setFormNamespace(namespace);
  }

  const handleClazzChange = (clazz: Clazz) => {
    setFormNamespace(clazz.namespace);
    setFormClazz(clazz);
  }

  const handleMethodChange = (method: Method) => {
    const clazz: Clazz = clazzesMap[method.classId];
    setFormNamespace(clazz.namespace);
    setFormClazz(clazz);
    setFormMethod(method);
  }

  const copyUserToken = async () => {
    await navigator.clipboard.writeText(userToken);
    setSnackbarMessage('User token copied!');
  }

  return (
    <div className={styles.MyForm}>
      <NamespaceInput
        namespaceChangedCallback = {handleNamespaceChange}
        formNamespace = {formNamespace}
      />
      <ClazzInput
        clazzChangedCallback = {handleClazzChange}
        formNamespace = {formNamespace}
        formClazz = {formClazz}
      />
      <MethodInput
        methodChangedCallback = {handleMethodChange}
        formClazz = {formClazz}
        formMethod = {formMethod}
      />
      {/*<ArgumentInput />*/}
      <div className={styles.toolbar}>
        <IconButton
          aria-label="Copy user token"
          size="small"
          onClick={copyUserToken}
        >
          <LinkIcon />
        </IconButton>
        <PersistenceInput />
        <DeletionInput />
        <Tools />
        <DiagramPositionInput />
        {/*Not shown, but useful because it receives inputs from outside
           when the application is embedded */}
        <LazilyAddInput />
      </div>
      <MySnackbar
        snackbarMessage={snackbarMessage}
        onSnackbarClosed={() => setSnackbarMessage('')}
      />
      <TextMeasurer />
    </div>
  );
}
